<template>
  <div>
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <help-tooltip v-if="errors.length" type="error">
        <span v-for="error in errors" :key="error.message">{{ error.message }}<br></span>
      </help-tooltip>
      <div class="el-input-group__prepend">
        Is
      </div>
      <el-select
        id="custom-state-select"
        v-close-on-zoom
        :value="state.check.id"
        placeholder="Custom state"
        filterable
        :disabled="readonly"
        @input="customStateId => selectCustomState(customStateId)"
      >
        <el-option
          v-for="customState in customStates"
          :key="customState.id"
          :label="customState.label"
          :value="customState.id"
        />
      </el-select>
      <el-select
        v-close-on-zoom
        :value="state.check.value"
        :disabled="readonly"
        @input="value => updateCheckValue(value)"
      >
        <el-option label="true" :value="true" />
        <el-option label="false" :value="false" />
      </el-select>
      <div class="el-input-group__append">
        ?
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'custom-state-check',
  components: {
    HelpTooltip,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        check: {
          id: null,
          operator: 'EQUAL',
          value: true,
        },
      },
      value: 0,
    };
  },
  computed: {
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.checkKey === this.ikey);
      return uniqBy(errors, 'message');
    },
    customStates() {
      return this.emitter.caseConf.caseLogicDescription.customStates;
    },
  },
  mounted() {
    this.state.check = this.getData(this.ikey) || this.state.check;
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    selectCustomState(customStateId) {
      this.state.check.id = customStateId;
      this.update();
    },
    updateCheckValue(value) {
      this.state.check.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'CUSTOM_STATE',
        id: this.state.check.id,
        operator: 'EQUAL',
        value: this.state.check.value,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
